var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-list-group-item',{staticClass:"d-flex justify-content-between align-items-center",on:{"action":function($event){return _vm.goTo(_vm.item)}}},[_vm._v(" "+_vm._s(_vm.dayFormat)+" "),_c('b-list-group-item-button',{attrs:{"disable":"","color":"primary"}},[_c('i',{staticClass:"fa-solid fa-angle-right"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }